import { h } from "preact";

import classname from "../../../foundation/utils/classname";

import IconArrowDown from "./IconArrowDown";
import IconProps from "./IconProps";

import styles from "./Icons.module.css";

function IconArrowLeft({ class: cssClass, ...props }: IconProps) {
    return (
        <IconArrowDown class={classname(styles.iconArrowLeft, cssClass)} {...props}/>
    );
}

export default IconArrowLeft;
